export const asyncAwaitThunk = store => {
  const dispatch = store.dispatch
  const getState = store.getState

  return next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState)
    }

    return next(action)
  }
}



// WEBPACK FOOTER //
// ./src/middleware/asyncAwaitThunk.js